import { FC, useState } from 'react'
import styles from './WeKnowALot.module.scss'
import { WeKnowALotProps } from './WeKnowALot.types'
import { Img } from 'components/basic/Img'
import { CountUp } from 'components/CountUp'
import { gsap } from 'gsap'
import { useGSAP } from '@gsap/react'
import { Button } from 'components/Phantom/Button'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'

export const WeKnowALot: FC<WeKnowALotProps> = (props) => {
	const [timeline, setTimeline] = useState<gsap.core.Timeline | null>(null)

	useGSAP(
		() => {
			gsap.registerPlugin(ScrollTrigger)
			if (!timeline) return

			const tl = gsap.timeline({
				ease: 'none',
				scrollTrigger: {
					trigger: '#sleep-count',
					start: `top 76%`,
					end: '+=200px',
					toggleActions: 'restart none none reverse',
				},
			})

			tl.fromTo(
				'#sleep-count',
				{
					opacity: 0,
				},
				{
					opacity: 1,
				},
				0
			)

			tl.add(timeline, 0)
		},
		{
			dependencies: [timeline],
			revertOnUpdate: true,
		}
	)

	return (
		<section className={styles.container}>
			<Img
				src={'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/8Sleep_13_02_24122028BLUE.jpg'}
				sources={[{ src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/mobile_we_know_sleep.jpg', mediaQuery: '(max-width: 1024px)' }]}
				alt={'A man sleeping on a bed with a pillow'}
				dprHeight={1500}
				objectFit={'cover'}
				className={styles.image}
			/>
			<header>
				<h2>We know a lot about sleep</h2>
				<p id={'sleep-count'}>
					We have over{' '}
					<CountUp
						endValue={500}
						animationStyle={'in-place'}
						trigger={true}
						duration={1}
						onTimelineReady={setTimeline}
					/>{' '}
					million hours of sleep analyzed, with clinical studies on over 18k subjects for 687k nights of data.
				</p>
				<Button.White
					id={'we-know-sleep-read-more'}
					href={'/product/pod-cover'}
				>
					Shop the Pod
				</Button.White>
			</header>
		</section>
	)
}
